var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      ref: "dialogRef",
      staticClass: "page-dialog center-dialog",
      attrs: {
        title: `会员游戏记录详情 - ${_vm.memberAccount}`,
        visible: _vm.dialogVisible,
        width: "1200px",
        "close-on-click-modal": false,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose,
        closed: _vm.handleClosed,
      },
      scopedSlots: _vm._u([
        {
          key: "footer",
          fn: function () {
            return [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.currentPage,
                  "page-sizes": [10, 20, 30, 50],
                  "page-size": _vm.pageSize,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.tableLoading,
              expression: "tableLoading",
            },
          ],
          staticClass: "detail-content",
        },
        [
          _c(
            "div",
            { staticClass: "filter-section" },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: true, model: _vm.filterForm, size: "mini" },
                },
                [
                  _c(
                    "el-row",
                    { attrs: { gutter: 16 } },
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "时间范围" } },
                            [
                              _c("DateTimeRangePicker", {
                                staticStyle: { width: "100%" },
                                attrs: { clearable: "" },
                                model: {
                                  value: _vm.filterForm.timeRange,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.filterForm, "timeRange", $$v)
                                  },
                                  expression: "filterForm.timeRange",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "el-col",
                        {
                          staticStyle: { "text-align": "right" },
                          attrs: { span: 12 },
                        },
                        [
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini", type: "primary" },
                              on: { click: _vm.handleFilter },
                            },
                            [_vm._v("筛选")]
                          ),
                          _c(
                            "el-button",
                            {
                              attrs: { size: "mini" },
                              on: { click: _vm.handleReset },
                            },
                            [_vm._v("重置")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "table-section" },
            [
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.tableData,
                    border: "",
                    stripe: "",
                    size: "small",
                    "show-summary": "",
                    "summary-method": _vm.getSummaries,
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      resizable: false,
                      prop: "game_title",
                      label: "游戏名称",
                      "min-width": "150",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      resizable: false,
                      prop: "game_id",
                      label: "游戏编号",
                      "min-width": "120",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      resizable: false,
                      prop: "win_amount",
                      label: "输赢情况",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                class:
                                  (scope.row.win_amount || 0) >= 0
                                    ? "text-positive"
                                    : "text-negative",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      (scope.row.win_amount || 0) >= 0
                                        ? "+"
                                        : ""
                                    ) +
                                    _vm._s(
                                      _vm.formatAmount(scope.row.win_amount)
                                    ) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      resizable: false,
                      prop: "bet_amount",
                      label: "下注金额",
                      width: "100",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.formatAmount(scope.row.bet_amount))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      resizable: false,
                      prop: "created_at",
                      label: "下注时间",
                      width: "140",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(_vm.formatTimestamp(scope.row.created_at))
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      resizable: false,
                      prop: "status",
                      label: "状态",
                      width: "80",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "el-tag",
                              {
                                attrs: {
                                  type:
                                    _vm.formatStatus(scope.row) === "Win"
                                      ? "success"
                                      : "danger",
                                },
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(_vm.formatStatus(scope.row)) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      resizable: false,
                      prop: "bet_id",
                      label: "注单号",
                      "min-width": "150",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              _vm._s(
                                scope.row.bet_id != null
                                  ? String(scope.row.bet_id)
                                  : "--"
                              )
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }